import { Link } from 'react-router-dom';
import SectionHeader from '@/components/base/SectionHeader';
import { dramas } from '@/mocks/dramas';
import { formatHeat } from '@/utils/drama';

export default function HotRanking() {
  const hot = [...dramas].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeader
          eyebrow="热度排行"
          title="今日热瓜速览"
          description="按站内讨论热度实时排序，先看大家都在追的这几出。"
          action={
            <Link
              to="/dramas"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              查看完整瓜田
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
          {hot.map((drama, index) => (
            <Link
              key={drama.id}
              to={`/drama/${drama.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-200 hover:border-primary-200 hover:bg-background-50"
            >
              <span
                className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                  index < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-relaxed text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                  {drama.title}
                </h3>
                <p className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    热度 {formatHeat(drama.heat)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-node-tree text-accent-600"></i>
                    {drama.timeline.length} 个节点
                  </span>
                  <span>已更新至 {drama.updatedAt}</span>
                </p>
              </div>
              <i className="ri-arrow-right-up-line mt-1 text-lg text-background-400 transition-colors group-hover:text-primary-500"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}